<template>
  <div class="page">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow light">PROJECTS</span>
        <h1>Systems built for<br><span>real environments.</span></h1>
        <p>Explore examples of the type of power, safety, security and infrastructure projects we deliver.</p>
      </div>
    </section>
    <section class="section">
      <div class="container projects-grid projects-page-grid">
        <ProjectCard v-for="project in projects" :key="project.title" v-bind="project" />
      </div>
    </section>
  </div>
</template>

<script>
import ProjectCard from '../components/ProjectCard.vue'
export default {
  name: 'Projects',
  components: { ProjectCard },
  data() {
    return {
      projects: [
        { category: 'POWER BACKUP', location: 'Port Harcourt', title: 'Commercial Hybrid Solar System', tone: 'blue' },
        { category: 'SECURITY', location: 'Rivers State', title: 'Estate CCTV & Perimeter Protection', tone: 'red' },
        { category: 'FIRE PROTECTION', location: 'Port Harcourt', title: 'Hydrant & Hose Reel System', tone: 'dark' },
        { category: 'POWER BACKUP', location: 'Rivers State', title: 'Office UPS & Inverter Installation', tone: 'blue' },
        { category: 'COMMUNICATION', location: 'Port Harcourt', title: 'Facility Intercommunication System', tone: 'dark' },
        { category: 'SECURITY', location: 'Port Harcourt', title: 'CCTV Surveillance Deployment', tone: 'red' }
      ]
    }
  }
}
</script>